<div *ngIf="payment" class="flex-fill d-flex flex-column p-2">
    <div class="btn-toolbar">
        <button *ngIf="hasChanges()" class="btn btn-success me-2" (click)="save()">Save</button>
        <button *ngIf="hasChanges()" class="btn btn-success me-2" (click)="save(true)">Save and Export</button>
        <button *ngIf="hasChanges()" class="btn btn-danger" (click)="cancel()">Cancel</button>
        <button *ngIf="!hasChanges()" class="btn btn-primary" (click)="close()">Close</button>
        <button *ngIf="!hasChanges() && this.paymentId !== 'new'" class="ms-3 btn btn-sm btn-success" (click)="readyToExport()" [disabled]="payment.readyToExport">
            Mark Ready To Export
        </button>
        <button *ngIf="!hasChanges() && this.paymentId !== 'new' && !this.payment.deleted" class="ms-3 btn btn-sm btn-danger" (click)="delete()">Delete Payment</button>
        <div class="d-flex ms-5 align-items-center me-3" style="max-width: 250px">
            <label class="mt-2 me-3">Payment Date</label>
            <dx-date-box [(value)]="payment.paymentDate" width="150px"></dx-date-box>
        </div>
        <div *ngIf="achInitiated" class="ach-initiated-banner ms-3">ACH Initiated</div>
    </div>
    <dx-form class="px-3" [formData]="payment" [colCount]="4" validationGroup="invoiceValidationGroup">
        <dxi-item itemType="group" caption="Dealer" [disabled]="readOnly">
            <dxi-item *ngIf="dealer">
                <div *dxTemplate>
                    <h3 class="mt-0 mb-1">{{ dealer.displayName }}</h3>
                    <div>{{ dealer.billAddress1 }}</div>
                    <div>{{ dealer.billAddress2 }}</div>
                    <div>
                        {{ dealer.billCity ? dealer.billCity + ',' : '' }}
                        {{ dealer.billState }}
                        {{ dealer.billZip }}
                    </div>
                </div>
            </dxi-item>
        </dxi-item>
        <dxi-item itemType="group" caption="Payment Info">
            <dxi-item [label]="{ text: 'Method' }">
                <div *dxTemplate>
                    <dx-select-box
                        [(value)]="payment.paymentMethodId"
                        [dataSource]="paymentMethods"
                        valueExpr="id"
                        displayExpr="name"
                        [disabled]="payment.quickBooksId"
                        (onValueChanged)="onMethodUpdate($event)"
                    ></dx-select-box>
                </div>
                <dxi-validation-rule type="required" message="Required"></dxi-validation-rule>
                <dxi-validation-rule type="range" [min]="1" message="Required"></dxi-validation-rule>
            </dxi-item>

            <dxi-item dataField="referenceNumber" [editorOptions]="{ disabled: payment.quickBooksId }"></dxi-item>
            <dxi-item *ngIf="payment.deleted" dataField="deleted" [editorOptions]="{ disabled: true }"></dxi-item>

            <dxi-item *ngIf="payment.paymentMethodId === 3" [label]="{ text: 'Credit Card' }">
                <div *dxTemplate>
                    <dx-select-box [(value)]="payment.creditCardId" [items]="creditCards" [valueExpr]="'id'" [displayExpr]="'name'" searchEnabled="true" searchMode="startswith">
                    </dx-select-box>
                </div>
            </dxi-item>

            <dxi-item *ngIf="payment.paymentMethodId === 3" [label]="{ text: 'Last Four Digits' }">
                <div *dxTemplate>
                    <dx-text-box [(value)]="payment.creditCardLastDigits"> </dx-text-box>
                </div>
                <dxi-validation-rule type="required" message="Required"></dxi-validation-rule>
                <dxi-validation-rule type="custom" message="Must be between 0000 and 9999" [validationCallback]="validateLastDigits" [reevaluate]="true"></dxi-validation-rule>
            </dxi-item>

            <dxi-item *ngIf="!readOnly" [label]="{ text: 'Payment Amount' }">
                <div *dxTemplate>
                    <dx-number-box
                        [(value)]="enteredAmount"
                        [format]="{ type: 'currency', precision: 2 }"
                        [step]="0"
                        [disabled]="!!payment.readyToExport || isCreditMemoMethod"
                        (onValueChanged)="onEnteredAmountChanged($event)"
                    >
                    </dx-number-box>
                </div>
            </dxi-item>

            <dxi-item *ngIf="payment?.paymentMethod?.isFloorplanMethod" [label]="{ text: 'Floorplan Fee' }">
                <div *dxTemplate>
                    <dx-number-box
                        [(value)]="payment.northpointFee"
                        [format]="{ type: 'currency', precision: 2 }"
                        [step]="0"
                        [disabled]="!!payment.readyToExport"
                        (onValueChanged)="onEnteredAmountChanged($event)"
                    >
                    </dx-number-box>
                </div>
                <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
                <dxi-validation-rule type="range" [min]="0.01" [message]="'Must be more than $0.01'"></dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="notes" editorType="dxTextArea" [label]="{ text: 'Payment Notes' }" [editorOptions]="{ height: 100 }"> </dxi-item>
        </dxi-item>

        <dxi-item itemType="group" caption="Totals">
            <dxi-item [label]="{ text: 'Amount Applied' }">
                <div *dxTemplate>
                    <dx-number-box
                        [(value)]="amountReceived"
                        [step]="0"
                        [readOnly]="true"
                        [format]="{ type: 'currency', precision: 2 }"
                        (onValueChanged)="creditCheck($event)"
                        [disabled]="readOnly"
                    ></dx-number-box>
                </div>
            </dxi-item>
            <dxi-item [label]="{ text: 'Balance' }">
                <div *dxTemplate>
                    <dx-number-box [value]="balance - amountReceived" [step]="0" [readOnly]="true" [format]="{ type: 'currency', precision: 2 }" [disabled]="true"></dx-number-box>
                </div>
            </dxi-item>
            <dxi-item *ngIf="key === 'new'" [label]="{ text: 'Beg. Balance' }">
                <div *dxTemplate>
                    <dx-number-box [value]="balance" [format]="{ type: 'currency', precision: 2 }" [disabled]="readOnly"></dx-number-box>
                </div>
            </dxi-item>
            <dxi-item [label]="{ text: 'Credit' }">
                <div *dxTemplate>
                    <dx-number-box [(value)]="creditAmount" [step]="0" [readOnly]="true" [format]="{ type: 'currency', precision: 2 }" [disabled]="readOnly"></dx-number-box>
                </div>
            </dxi-item>
        </dxi-item>
        <dxi-item itemType="group" caption="QuickBooks Info" [disabled]="true">
            <dxi-item dataField="readyToExport" [label]="{ text: 'Ready to Export' }" [editorOptions]="{ displayFormat: 'shortDateShortTime', readOnly: true }"> </dxi-item>
            <dxi-item dataField="quickBooksId" [label]="{ text: 'QuickBooks Id' }" [editorOptions]="{ readOnly: true }"> </dxi-item>
            <dxi-item dataField="quickBooksLastExport" [label]="{ text: 'QuickBooks Last Exported' }" [editorOptions]="{ displayFormat: 'shortDateShortTime', readOnly: true }">
            </dxi-item>
        </dxi-item>
    </dx-form>
    <div class="d-flex flex-fill">
        <dx-data-grid
            #dataGrid
            *ngIf="paymentLines"
            keyExpr="id"
            height="95%"
            class="p-2 me-4 mb-2 flex-fill grid-fill"
            [dataSource]="paymentLines"
            [showBorders]="true"
            [showRowLines]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onRowUpdated)="rowUpdated($event)"
            (onCellPrepared)="onCellPrepared($event)"
            (onEditingStart)="onEditingStart($event)"
            [customizeColumns]="customizeColumns"
        >
            <dxi-column dataField="applyPayment" caption="Apply" width="60" [visible]="!readOnly" [allowEditing]="false" cellTemplate="applyTemplate"></dxi-column>
            <dxi-column dataField="lineNumber" caption="No." [visible]="true" width="60" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>
            <dxi-column dataField="generatedDescription" caption="Description" width="175" cellTemplate="descriptionTemplate"></dxi-column>
            <dxi-column dataField="invoiceDate" caption="Date" width="100" [format]="{ type: 'shortDate' }"></dxi-column>
            <dxi-column dataField="invoiceDueDate" caption="Due Date" width="100" [format]="{ type: 'shortDate' }"></dxi-column>
            <dxi-column dataField="invoiceAmount" [format]="{ type: 'currency', precision: 2 }" width="125"></dxi-column>
            <dxi-column dataField="startingBalance" [format]="{ type: 'currency', precision: 2 }" [visible]="key === 'new'" width="100"></dxi-column>
            <dxi-column dataField="remainingBalance" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column>
            <dxi-column dataField="amount" [format]="{ type: 'currency', precision: 2 }" width="100" [editorOptions]="{ step: 0 }"></dxi-column>
            <dxi-column dataField="relatedPaymentIds" caption="Related Payments" width="150" cellTemplate="relatedPaymentTemplate"></dxi-column>
            <dxi-column dataField="creditAmount" [format]="{ type: 'currency', precision: 2 }" width="100" [editorOptions]="{ step: 0 }"></dxi-column>
            <dxi-column dataField="paymentCredit.creditOrderInvoices" caption="Credit Invoice" width="140" cellTemplate="creditOrderInvoicesTemplate"></dxi-column>
            <dxi-column dataField="notes"></dxi-column>

            <div *dxTemplate="let cell of 'applyTemplate'">
                <dx-check-box [value]="cell.data.applyPayment" [disabled]="readOnly || isCreditMemoMethod" (onValueChanged)="onApplyToggle(cell.data, $event)"></dx-check-box>
            </div>

            <div *dxTemplate="let cell of 'descriptionTemplate'">
                <a [routerLink]="[]" (click)="openInvoiceDialog(cell.data.invoiceId)">{{ cell.value || '' }}</a>
            </div>

            <div *dxTemplate="let cell of 'relatedPaymentTemplate'">
                <span *ngFor="let paymentId of cell.data.relatedPaymentIds; index as i" class="pe-1">
                    <a *ngIf="cell" [routerLink]="[]" (click)="openPayment(paymentId)">#{{ paymentId + (i + 1 < cell.data.relatedPaymentIds.length ? ', ' : '') }}</a>
                </span>
            </div>

            <div *dxTemplate="let cell of 'creditOrderInvoicesTemplate'">
                <span *ngFor="let invoice of cell.data.paymentCredit?.creditOrderInvoices; index as i" class="pe-1">
                    <a [routerLink]="[]" (click)="openInvoiceDialog(invoice.id)"
                        >{{ invoice.invoiceNumber }}{{ i + 1 < cell.data.paymentCredit.creditOrderInvoices.length ? ',' : '' }}</a
                    >
                </span>
            </div>
            <dxo-summary>
                <dxi-total-item column="invoiceAmount" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"></dxi-total-item>
                <dxi-total-item column="amount" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"></dxi-total-item>
            </dxo-summary>

            <dxo-editing [mode]="'cell'" [allowUpdating]="true"></dxo-editing>
            <dxo-selection [mode]="'multiple'" [showCheckBoxesMode]="'none'"></dxo-selection>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="invoice-lines-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-sm btn-secondary me-2 mb-2" (click)="markOldInvoiceAsPaid()" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
                    Mark Old Invoice As Paid
                </button>
                <button class="btn btn-sm btn-danger me-2 mb-2" (click)="removeCredit()" [disabled]="readOnly || !canRemoveCredit()">Clear Credit</button>
                <button class="btn btn-sm btn-success me-2 mb-2" (click)="openApplyCreditDialog()" [disabled]="readOnly || !credits || credits.length === 0">Add Credit</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span class="me-3" *ngIf="!readOnly">
                    <em><strong>Check Apply to auto-fill the amount; the amount is locked while Apply is checked</strong></em>
                </span>
            </div>
        </dx-data-grid>

        <dx-data-grid
            #creditsGrid
            *ngIf="credits"
            keyExpr="id"
            height="400px"
            class="p-2 me-4 mb-2 flex-fill grid-fill"
            [dataSource]="credits"
            [showBorders]="true"
            [showRowLines]="true"
            (onToolbarPreparing)="onCreditsToolbarPreparing($event)"
        >
            <dxi-column dataField="created" width="100"></dxi-column>
            <dxi-column dataField="availableAmount" caption="Credit" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="balance" caption="Remaining" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="creditOrder.invoiceNumber" caption="Sales Order #" width="120" cellTemplate="salesOrderTemplate"></dxi-column>
            <dxi-column dataField="creditOrderInvoices" caption="Invoice" width="150" cellTemplate="creditOrderInvoicesTemplate"></dxi-column>

            <div *dxTemplate="let cell of 'salesOrderTemplate'">
                <a *ngIf="cell.data.creditOrderId" [routerLink]="[]" (click)="openOrderDialog(cell.data.creditOrderId)">{{ cell.value }}</a>
            </div>

            <div *dxTemplate="let cell of 'creditOrderInvoicesTemplate'">
                <span *ngFor="let invoice of cell.data.creditOrderInvoices; index as i" class="pe-1">
                    <a [routerLink]="[]" (click)="openInvoiceDialog(invoice.id)">{{ invoice.invoiceNumber }}{{ i + 1 < cell.data.creditOrderInvoices.length ? ',' : '' }}</a>
                </span>
            </div>

            <dxo-selection [mode]="'single'"></dxo-selection>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="credits-grid"></dxo-state-storing>
        </dx-data-grid>
    </div>
</div>
